import { JSX } from "react";

import { Box, useTheme } from "@mui/material";
import sharedStyles from "src/constants/styles";

interface MetricHeaderProps {
  leftContent: JSX.Element;
  rightContent?: JSX.Element;
}

export default function MetricHeader({ leftContent, rightContent }: MetricHeaderProps) {
  const theme = useTheme();

  return (
    <Box sx={sharedStyles(theme).flexboxRow}>
      <Box sx={sharedStyles(theme).flexboxColStart}>{leftContent}</Box>

      <Box sx={sharedStyles(theme).flexboxColEnd}>{rightContent}</Box>
    </Box>
  );
}
